module.exports = __webpack_public_path__ + "img/slash_arrow.e4178dc7.png";